import { Injectable, inject } from '@angular/core';
import { Apollo, gql } from 'apollo-angular';
import { Observable, map } from 'rxjs';
import {
  EhrLabQueriesFindAllEhrmcuAndEhrLabArgs,
  EhrmcuAndEhrLabQueryResult
} from '../../../../../interfaces/schema';

/**
 * @description HomeMyHealthPassportHealthRecord Service.
 * @exports
 * @class HomeMyHealthPassportHealthRecordService
 */
@Injectable()
export class HomeMyHealthPassportHealthRecordService {
  private readonly apollo: Apollo = inject(Apollo);

  /**
   * Mcus query.
   *
   * @param {EhrLabQueriesFindAllEhrmcuAndEhrLabArgs} variables Variables.
   * @returns {Observable<EhrmcuAndEhrLabQueryResult>}
   * @memberof HomeMyHealthPassportHealthRecordService
   */
  findAllEHRMCUAndEHRLab(
    variables?: EhrLabQueriesFindAllEhrmcuAndEhrLabArgs
  ): Observable<EhrmcuAndEhrLabQueryResult> {
    const query = gql`
      query FindAllEHRMCUAndEHRLab(
        $where: EHRMCUAndEHRLabQueryFilter
        $sort: EHRMCUAndEHRLabQuerySortyBy
        $limit: Int
        $offset: Int
        $count: Boolean
      ) {
        EHR {
          Lab {
            findAllEHRMCUAndEHRLab(
              where: $where
              sort: $sort
              limit: $limit
              offset: $offset
              count: $count
            ) {
              count
              results {
                id
                type
                ehrOrderId
                ehrLabId
                takenAt
                resultTypeId
                resultType {
                  id
                  name
                }
                ehrLab {
                  id
                  resultName
                  laboratorium
                  description
                  ownerProfileId
                  ehrLabPatient {
                    name
                    email
                  }

                  ownerProfile {
                    name
                    email
                  }
                }
                ehrOrder {
                  id
                  code
                  status
                  invoice
                  createdAt
                  ehrLabResultType {
                    id
                    name
                  }
                  buyerProfile {
                    id
                    name
                  }
                }
                createdAt
              }
            }
          }
        }
      }
    `;
    return this.apollo
      .query({ query, variables })
      .pipe(
        map(
          ({ data }) =>
            (data as any)?.EHR?.Lab
              ?.findAllEHRMCUAndEHRLab as EhrmcuAndEhrLabQueryResult
        )
      );
  }
}
